import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import SelectDropdown from 'react-native-select-dropdown';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import * as GlobalVariableContext from '../config/GlobalVariableContext';

export const Dropdown = ({
  setToggleAddCategory,
  setToggleNewCategory,
  allCategories,
  setNumberInputs,
  numberInputs,
  setTotalIncomePerCategories,
  totalIncomePerCategories,
  usersCategories,
  setUsersCategories,
  headType,
}) => {
  const variables = GlobalVariableContext.useValues();
  const textColor = variables.SWITCH_SCREEN_MODE ? '#000000' : '#FFFFFF';
  const data = [...allCategories, { title: 'Add New Category', icon: 'plus' }];

  const initTableRows = (rowCount, colCount = 12, existingData = []) => {
    const newRows = Array(rowCount - existingData.length)
      .fill()
      .map(() => Array(colCount).fill(0));
    return [...existingData, ...newRows];
  };

  const onSelectItem = (selectedItem, index) => {
    if (selectedItem.title === 'Add New Category') {
      setToggleNewCategory(true);
    } else {
      let newItemTitle = selectedItem.title;
      let newItemCount = 1;

      while (
        usersCategories.find(item => {
          let itemTitle;
          if (item.custom_value && item.custom_value === true) {
            itemTitle = item.title;
          } else if (item._expense_heads && item._expense_heads.title) {
            itemTitle = item._expense_heads.title;
          } else {
            return false;
          }

          return itemTitle === newItemTitle;
        })
      ) {
        newItemTitle = `${selectedItem.title} ${++newItemCount}`;
      }

      const newItem = {
        ...selectedItem,
        [headType]: { title: newItemTitle },
        default: true,
        custom: false,
      };

      const updatedCategories = [...usersCategories, newItem];
      setUsersCategories(updatedCategories);
      setToggleAddCategory(false);

      const newNumberInputs = initTableRows(
        updatedCategories.length,
        12,
        numberInputs
      );
      setNumberInputs(newNumberInputs);

      const updatedTotalIncome = [...totalIncomePerCategories, 0];
      setTotalIncomePerCategories(updatedTotalIncome);

      setToggleAddCategory(false);
    }
  };

  return (
    <View style={styles.container}>
      <SelectDropdown
        data={data}
        onSelect={onSelectItem}
        renderButton={(selectedItem, isOpen) => {
          return (
            <View style={styles.dropdown1ButtonStyle}>
              <Icon
                name={selectedItem ? selectedItem.icon : ''}
                style={styles.dropdown1ButtonIconStyle}
              />
              <Text
                style={[styles.dropdown1ButtonTxtStyle, { color: textColor }]}
              >
                {(selectedItem && selectedItem.title) || 'Select Category'}
              </Text>
              <Icon
                name={isOpen ? 'chevron-up' : 'chevron-down'}
                style={[styles.dropdown1ButtonArrowStyle, { color: textColor }]}
              />
            </View>
          );
        }}
        renderItem={(item, index, isSelected) => {
          return (
            <View
              style={{
                ...styles.dropdown1ItemStyle,
                ...(isSelected && { backgroundColor: 'grey' }),
              }}
            >
              <Icon name={item.icon} style={styles.dropdown1ItemIconStyle} />
              <Text style={styles.dropdown1ItemTxtStyle}>{item.title}</Text>
            </View>
          );
        }}
        dropdownStyle={styles.dropdown1MenuStyle}
        showsVerticalScrollIndicator={false}
        search
        searchInputStyle={styles.dropdown1SearchInputStyle}
        searchInputTxtColor={'#FFFFFF'}
        searchPlaceHolder={'Search here'}
        searchPlaceHolderColor={'#FFFFFF'}
        renderSearchInputLeftIcon={() => {
          return <FontAwesome name={'search'} color={'#FFFFFF'} size={12} />;
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 0,
  },
  dropdown1ButtonStyle: {
    width: '100%',
    height: 25,
    borderRadius: 0,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 4,
    backgroundColor: 'transparent',
  },
  dropdown1ButtonTxtStyle: {
    flex: 1,
    fontSize: 10,
    fontWeight: '500',
    textAlign: 'center',
  },
  dropdown1ButtonArrowStyle: {
    fontSize: 12,
  },
  dropdown1MenuStyle: {
    backgroundColor: '#444444',
    borderRadius: 0,
  },
  dropdown1SearchInputStyle: {
    height: 25,
    backgroundColor: '#444444',
    borderBottomWidth: 1,
    borderBottomColor: '#FFFFFF',
    fontSize: 12,
  },
  dropdown1ItemStyle: {
    width: '100%',
    flexDirection: 'row',
    paddingHorizontal: 4,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 4,
    borderBottomWidth: 1,
    borderBottomColor: '#444444',
  },
  dropdown1ItemTxtStyle: {
    flex: 1,
    fontSize: 10,
    fontWeight: '500',
    color: '#FFFFFF',
  },
  dropdown1ItemIconStyle: {
    fontSize: 10,
    marginRight: 8,
    color: '#FFFFFF',
  },
});
